<template>
    <section class="mt-16">
      <v-breadcrumbs
          v-if="this.$root.$vuetify.theme.isDark"
          large
          :items="crumbs"
          divider="/"
          light
          :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
        ></v-breadcrumbs>
        <v-breadcrumbs
          v-else
          :items="crumbs"
          divider="/"
          light
          :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
        ></v-breadcrumbs>
  
        <h1 class="primary--text">
            <rp-icon icon="rp-clientes-blue-filled" class="mr-2"/> <span>{{$t('menu.clients_management')}}</span>
        </h1>
        <v-row>
          <v-col cols="12" md="auto">
            <rp-icon
                icon="rp-eye-blue-filled"
                class="mb-n2"
              /><v-icon class="ml-2" color="secondary" small>mdi-forward</v-icon>
              <span :class="this.$root.$vuetify.theme.isDark ? 'primary--text text-caption' : 'primary--text text-caption'">{{$t('globals.visualize')}}</span>
          </v-col>
          <v-col cols="12" md="auto">
            <v-icon color="red" class="ml-4">
              mdi-delete
            </v-icon><v-icon class="ml-2" small color="secondary">mdi-forward</v-icon>
            <span :class="this.$root.$vuetify.theme.isDark ? 'primary--text text-caption' : 'primary--text text-caption'">{{$t('globals.remove')}}</span>
          </v-col>
        </v-row>

        <div style="position:relative">
        
        <v-switch
          v-if="this.$root.$vuetify.theme.isDark "
          style="position:absolute"
          v-model="filter.deleted_client"
          color="success"
          @change="searchClients"
          light
          :label="$t('client.show_deleted')"
        ></v-switch>
        <v-switch
          v-else
          style="position:absolute"
          v-model="filter.deleted_client"
          color="success"
          @change="searchClients"
          :label="$t('client.show_deleted')"
        ></v-switch>
        
        <v-container>
          <v-speed-dial
            absolute
            v-model="speedDial"
            top
            right
            direction="bottom"
            :open-on-hover="true"
          >
            <template v-slot:activator>
              <v-tooltip right color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs" v-on="on"
                    v-model="speedDial"
                    color="primary"
                    dark
                    x-large
                    fab
                  >
                    <v-icon v-if="speedDial">
                      mdi-close
                    </v-icon>
                    <v-icon v-else>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{$t('globals.options')}}</span>
              </v-tooltip>
            </template>
            <v-tooltip right color="secondary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs" v-on="on"
                  fab
                  dark
                  small
                  color="secondary"
                  large
                  :to="'/' + $session.get('domain') + '/admin/clients/create'"
                  v-if="$root.session.hasPermission(['super', 'clients.create'])"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{$t('globals.register')}}</span>
            </v-tooltip>
          </v-speed-dial>
        </v-container>
        <v-data-table
          :headers="headers"
          :items="items"
          :server-items-length="total"
          :loading="loading"
          :footer-props="tableFooter"
          :options.sync="options"
          :class="this.$root.$vuetify.theme.isDark ? 'secondary mt-16' : 'mt-16'"
          locale="pt-pt"
        >
        <template v-slot:item.created_at="{ item }">
            {{ getTableDate(item.created_at)}}
        </template>

        <template v-slot:item.updated_at="{ item }">
            {{ getTableDate(item.updated_at)}}
        </template>

        <template v-slot:item.deleted_client="{ item }">
          <v-row>
            <v-col cols="12" md="auto">
              <IconView
                  class="mr-2"
                  @click="viewClient(item)"
                />

              <IconRemove
                  v-if="$root.session.hasPermission(['super', 'clients.delete'])"
                  :reverse="filter.deleted_client"
                  @on-submit="deleteClient(item)"
                />

            </v-col>
          </v-row>
        </template>

          
        </v-data-table>
        
      </div>
      <v-navigation-drawer
          fixed
          right
          v-model="searching"
          hide-overlay
          width="520"
          class="pt-6"
        >
        <v-list>
          <v-list-item>
            <v-btn fab small color="secondary" @click="searching = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-btn absolute right small color="error" @click="resetClients">
              {{$t('globals.clean_fields')}}
            </v-btn>
          </v-list-item>
        </v-list>

      </v-navigation-drawer>


    </section>
</template>
<script>
import dayjs from 'dayjs';
import Client from "@/api/Client.js";
import IconRemove from '@/components/ui/IconRemove.vue';
import IconView from '@/components/ui/IconView.vue';

export default {
components: {
    IconRemove,
    IconView
},
watch: {
    'options': {
    immediate: false,
    handler () {
        setTimeout(() => {this.searchClients()}, 10);
    },
    deep: true,
    },
},
data: () => ({
    client_selected: null,
    items: [],
    total: 0,
    loading: false,
    searching: false,
    options: {},
    speedDial:false,
    filter: {
        name:null,
        deleted_client: false
    },
    status: [],
    approved:false,
    addClient: false
}),
mounted(){

    /*if(!this.$root.session.hasPermission(["super", "diaries.read"])) {
    this.$router.push('/admin');
    }*/

    //this.searchClients();
},
methods:{
    getTableDate(date) {
        return date != null ? dayjs(date).toDate().toLocaleDateString() : "-";
    },
    fillBaseData() {
    this.addClient = false
    if(localStorage["clients-" + this.$root.session.id] != undefined){

        let data = JSON.parse(localStorage["clients-" + this.$root.session.id]);

        this.filter = data.filter;

        this.options = data.options;
    }
    },
    searchClients(event){
        if(!!event && event.type == 'submit'){
            this.options.page = 1;
        }

        this.loading = true;

        let filter = {...this.filter};
        
        let request = {
            sortBy: this.options.sortBy,
            sortDesc: this.options.sortDesc,
            page: this.options.page,
            limit: this.options.itemsPerPage,
            deleted_client: this.filter.deleted_client
        };
        
        Object.assign(request, filter);

        localStorage["clients-" + this.$root.session.id] = JSON.stringify({
            filter: this.filter,
            options: this.options,
        });

        Client.search(request).then(response => {

            let data = response.data;

            this.total = data.total;

            this.items = data.data.map((item) => {

            this.searching = false;

            return item;  
            });

            this.loading = false;

        });
    },
    resetClients()
    {
        this.searchClients();
    },
    deleteClient(item){
        if(this.filter.deleted_client)
            item.deleted_client = false;
        else
            item.deleted_client = true
        Client.update(item, item.id)
            .then(() => {
            this.searchClients();
            });
    },
    viewClient(item){
        let domain = '/' + this.$session.get('domain')
        let path = domain + '/admin/clients/' + item.id
  
  
        this.$router.push(path);
    }
},
computed: {
    headers(){
        let he = [
            {
            text: this.$t('globals.reference'),
            sortable: true,
            value: 'reference',
            },
            {
            text: this.$t('globals.name'),
            sortable: true,
            value: 'name',
            },
            {
            text: this.$t('globals.nif'),
            sortable: true,
            value: 'nif',
            },
            {
            text: this.$t('globals.email'),
            sortable: true,
            value: 'email',
            },
            {
            text: this.$t('globals.contact'),
            sortable: true,
            value: 'telephone',
            },
            {
            text: this.$t('globals.created_at'),
            sortable: true,
            value: 'created_at',
            },
            {
            text: this.$t('globals.options'),
            sortable: false,
            width: '200px',
            value: 'deleted_client',
            }
        ]
        return he
    },
    tableFooter(){
        let t = this.$t("globals.lines_datatable")
        let a = [5, 10, 15, 20];
        return {
            'items-per-page-options': a,
            'items-per-page-text': t
        }
    }, 
    crumbs: function() {
        return [
            {
            text: this.$t('menu.dashboard'),
            disabled: false,
            to: '/admin',
            exact: true,
            },
            {
            text: this.$t('menu.clients_management'),
            disabled: true,
            to: window.location.href,
            exact: true,
            },
        ];
    }
}
};
</script>